import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Innovacrystaonrentinnavimumbai() {



  const cardData = {
    keyword: " Innova Crysta On Rent in Navi Mumbai  ",


"headingDescription": "Royal Route Cab offers premium Innova Crysta on rent in Navi Mumbai, providing spacious, comfortable, and reliable travel solutions for families, corporate groups, airport transfers, weddings, and outstation journeys. Toyota Innova Crysta is one of the most preferred 6/7-seater MPVs known for its luxury interiors, smooth ride quality, powerful performance, and excellent safety features, making it ideal for both city and long-distance travel. Whether you need a local ride, airport pickup, or highway journey, our well-maintained Innova Crysta ensures a stress-free experience with professional drivers and clean vehicles. We offer flexible booking options including one-way, round trip, and full-day rental. With 24/7 availability, transparent pricing, and no hidden charges, Royal Route Cab is a trusted choice for Innova Crysta rental in Navi Mumbai.",

"topPlaces": [
  {
    "title": "Innova Crysta On Rent in Navi Mumbai",
    "description": "Innova Crysta on rent in Navi Mumbai is a premium and spacious travel option suitable for families, corporate groups, and tourists. It offers superior comfort, ample legroom, and smooth performance for both local and outstation journeys."
  },
  {
    "title": "Navi Mumbai Innova Crysta Rental Service",
    "description": "Innova Crysta rental service in Navi Mumbai provides reliable transportation for airport transfers, business travel, weddings, and family outings with professional drivers and comfortable seating."
  },
  {
    "title": "Innova Crysta with Driver Navi Mumbai",
    "description": "Innova Crysta with driver service in Navi Mumbai ensures a hassle-free travel experience with trained chauffeurs. It is ideal for city rides, long-distance travel, and special occasions."
  },
  {
    "title": "Airport Transfer Innova Crysta Navi Mumbai",
    "description": "Airport transfer service using Innova Crysta in Navi Mumbai is preferred for its spacious interiors and luggage capacity, making it ideal for smooth pickup and drop services."
  },
  {
    "title": "Family Innova Crysta Hire Navi Mumbai",
    "description": "Family Innova Crysta hire in Navi Mumbai is perfect for group travel, offering comfort, safety, and enough space for all passengers during local or outstation trips."
  },
  {
    "title": "Corporate Innova Crysta Service Navi Mumbai",
    "description": "Corporate Innova Crysta service in Navi Mumbai is designed for business professionals needing reliable and comfortable transportation for meetings, events, and office travel."
  },
  {
    "title": "Outstation Innova Crysta from Navi Mumbai",
    "description": "Outstation Innova Crysta from Navi Mumbai is widely used for trips to destinations like Pune, Lonavala, Nashik, and Mahabaleshwar, offering a smooth and comfortable ride."
  },
  {
    "title": "Luxury Innova Crysta Rental Navi Mumbai",
    "description": "Luxury Innova Crysta rental in Navi Mumbai provides premium interiors, advanced comfort features, and a smooth driving experience for VIP travel and special occasions."
  },
  {
    "title": "Affordable Innova Crysta Navi Mumbai",
    "description": "Affordable Innova Crysta rental in Navi Mumbai offers a cost-effective yet premium travel solution for families and groups without compromising on comfort."
  },
  {
    "title": "One Way Innova Crysta Cab Navi Mumbai",
    "description": "One way Innova Crysta cab service in Navi Mumbai is ideal for point-to-point travel, providing convenient and economical transportation for intercity and airport trips."
  }
],






services: [
  {
    name: "Innova Crysta on Rent in Navi Mumbai",
    description: "Innova Crysta on rent in Navi Mumbai offers premium and spacious travel for families, corporate clients, and group travelers. Known for luxury interiors and smooth performance, it is ideal for city travel and outstation trips. Professional drivers ensure safety. It guarantees a comfortable and high-end experience."
  },
  {
    name: "Innova Crysta Rental Navi Mumbai",
    description: "Innova Crysta rental Navi Mumbai provides flexible rental options for hourly, daily, and outstation travel. Customers can choose plans based on their needs. Spacious seating and luggage space enhance comfort. It ensures a reliable travel experience."
  },
  {
    name: "Innova Crysta Hire in Navi Mumbai",
    description: "Innova Crysta hire in Navi Mumbai offers premium vehicle booking for personal and business travel. Ideal for airport transfers, corporate travel, and family trips. Clean vehicles and trained drivers ensure comfort. It guarantees smooth journeys."
  },
  {
    name: "Innova Crysta Car Rental Navi Mumbai",
    description: "Innova Crysta car rental Navi Mumbai provides a luxury travel option with modern features and comfortable seating. Suitable for long-distance and city travel. Flexible booking options enhance convenience. It ensures a pleasant ride."
  },
  {
    name: "Innova Crysta Taxi Service Navi Mumbai",
    description: "Innova Crysta taxi service Navi Mumbai ensures reliable transportation with premium vehicles and professional drivers. Ideal for corporate clients and families. Comfortable interiors enhance travel experience. It guarantees a smooth journey."
  },
  {
    name: "Book Innova Crysta in Navi Mumbai",
    description: "Book Innova Crysta in Navi Mumbai with easy online booking and instant confirmation. Customers can select pickup location, timing, and trip type. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Innova Crysta Rental Service Navi Mumbai",
    description: "Innova Crysta rental service Navi Mumbai offers dependable and flexible travel solutions for local and outstation journeys. Well-maintained vehicles and trained drivers ensure comfort. It guarantees reliable service."
  },
  {
    name: "Best Innova Crysta on Rent Navi Mumbai",
    description: "Best Innova Crysta on rent Navi Mumbai ensures top-quality vehicles, professional drivers, and excellent service. This service focuses on comfort, safety, and punctuality. It guarantees a premium travel experience."
  },
  {
    name: "Cheapest Innova Crysta Rental Navi Mumbai",
    description: "Cheapest Innova Crysta rental Navi Mumbai offers budget-friendly luxury travel options. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers seeking premium comfort. It ensures economical travel."
  },
  {
    name: "Innova Crysta Airport Pickup Navi Mumbai",
    description: "Innova Crysta airport pickup Navi Mumbai provides seamless pickup services from airport terminals. Spacious interiors make it ideal for luggage-heavy travel. Professional drivers ensure timely service. It guarantees a smooth transfer."
  },
  {
    name: "Innova Crysta Airport Drop Navi Mumbai",
    description: "Innova Crysta airport drop Navi Mumbai ensures timely transportation to the airport for departures. Comfortable vehicles enhance travel convenience. Ideal for families and business travelers. It guarantees stress-free travel."
  },
  {
    name: "Innova Crysta Outstation Rental Navi Mumbai",
    description: "Innova Crysta outstation rental Navi Mumbai is perfect for long-distance travel and intercity trips. Spacious seating and smooth performance make it ideal for highways. Professional drivers ensure safety. It guarantees a comfortable journey."
  },
  {
    name: "Innova Crysta for Long Trip Navi Mumbai",
    description: "Innova Crysta for long trip Navi Mumbai offers comfortable and reliable travel for extended journeys. Premium seating and advanced features enhance travel experience. Ideal for family vacations and tours. It ensures a relaxed ride."
  },
  {
    name: "Innova Crysta on Rent in Vashi",
    description: "Innova Crysta on rent in Vashi provides premium travel options for residents and business travelers. Ideal for local and outstation journeys. Professional drivers ensure safety. It guarantees a smooth experience."
  },
  {
    name: "Innova Crysta on Rent in Nerul",
    description: "Innova Crysta on rent in Nerul offers comfortable and spacious travel for families and groups. Ideal for city rides and long-distance travel. Clean vehicles enhance comfort. It ensures a reliable journey."
  },
  {
    name: "Innova Crysta on Rent in Kharghar",
    description: "Innova Crysta on rent in Kharghar provides luxury travel with modern features and spacious seating. Suitable for business and personal trips. Professional drivers ensure smooth rides. It guarantees a premium experience."
  },
  {
    name: "Innova Crysta on Rent in Panvel",
    description: "Innova Crysta on rent in Panvel offers dependable transportation for local and outstation travel. Comfortable interiors enhance travel experience. Ideal for families and corporate clients. It ensures a smooth journey."
  },
  {
    name: "AC Innova Crysta on Rent in Navi Mumbai",
    description: "AC Innova Crysta on rent in Navi Mumbai provides comfortable travel with fully air-conditioned premium vehicles. Ideal for long journeys and summer travel. Spacious seating enhances comfort. It guarantees a pleasant experience."
  }
],

tableData: [
  ["Innova Crysta on Rent in Navi Mumbai", "Innova Crysta Rental Navi Mumbai"],
  ["Innova Crysta Hire in Navi Mumbai", "Innova Crysta Car Rental Navi Mumbai"],
  ["Innova Crysta Taxi Service Navi Mumbai", "Book Innova Crysta in Navi Mumbai"],
  ["Innova Crysta Rental Service Navi Mumbai", "Best Innova Crysta on Rent Navi Mumbai"],
  ["Cheapest Innova Crysta Rental Navi Mumbai", "Innova Crysta Airport Pickup Navi Mumbai"],
  ["Innova Crysta Airport Drop Navi Mumbai", "Innova Crysta Outstation Rental Navi Mumbai"],
  ["Innova Crysta for Long Trip Navi Mumbai", "Innova Crysta on Rent in Vashi"],
  ["Innova Crysta on Rent in Nerul", "Innova Crysta on Rent in Kharghar"],
  ["Innova Crysta on Rent in Panvel", "AC Innova Crysta on Rent in Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Premium Innova Crysta on Rent in Navi Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers luxury Innova Crysta rental in Navi Mumbai, perfect for family travel, airport transfers, corporate trips, and outstation journeys."
  },
  {
    WhyChooseheading: "Spacious & Comfortable 6–7 Seater SUV",
    WhyChoosedescription: "Innova Crysta provides premium seating, ample legroom, and large luggage space, making it ideal for group and long-distance travel."
  },
  {
    WhyChooseheading: "Affordable Per KM & Daily Pricing",
    WhyChoosedescription: "Innova Crysta rental starts from approximately ₹18 to ₹25 per km and ₹2500 to ₹4500 per day depending on package and duration." 
  },
  {
    WhyChooseheading: "Experienced & Professional Drivers",
    WhyChoosedescription: "Our drivers are trained, verified, and experienced in city and highway routes, ensuring safe and smooth travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear billing including tolls and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Innova Crysta rental service in Navi Mumbai is available round the clock for all travel needs."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Choose from hourly packages, full-day rental, airport transfers, one-way, or round-trip bookings."
  },
  {
    WhyChooseheading: "Trusted SUV Rental Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Innova Crysta rental in Navi Mumbai with punctual service and clean vehicles."
  }
]

};

const faqData = [
  { question: "What is the price of Innova Crysta on rent in Navi Mumbai?", answer: "The price starts from ₹18–₹25 per km or ₹2500–₹4500 per day depending on package and rental duration." },
  { question: "How many passengers can travel in Innova Crysta?", answer: "Innova Crysta can comfortably seat 6 to 7 passengers." },
  { question: "Is Innova Crysta suitable for long-distance travel?", answer: "Yes, it is one of the best SUVs for long-distance travel due to comfort and space." },
  { question: "Do you provide driver with rental?", answer: "Yes, all Innova Crysta rentals include professional drivers." },
  { question: "Is rental available 24 hours?", answer: "Yes, our service operates 24/7." },
  { question: "Can I book for airport pickup?", answer: "Yes, we provide Navi Mumbai and Mumbai airport pickup and drop services." },
  { question: "Do you provide one-way booking?", answer: "Yes, both one-way and round-trip options are available." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly." },
  { question: "What is included in rental fare?", answer: "Fare usually includes driver charges, but toll and parking may be extra depending on package." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Patil",
    feedback: "Innova Crysta on rent in Navi Mumbai with Royal Route Cabs felt premium and very comfortable. The vehicle was clean, spacious, and perfect for long family travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Deshmukh",
    feedback: "Great experience using Innova Crysta rental in Navi Mumbai. The ride was smooth, the car was well-maintained, and the journey felt safe and relaxing.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta on Rent in Navi Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/innova-crysta-on-rent-navi-mumbai.jpg", // replace if needed
  "description": "Book Innova Crysta on rent in Navi Mumbai with Royal Route Cabs for premium, spacious, and comfortable travel. Ideal for airport transfers, outstation trips, long-distance journeys, and corporate travel across Vashi, Nerul, Kharghar, and Panvel.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "13/km", // indicative premium vehicle rate (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/innova-crysta-on-rent-in-navi-mumbai"
  }
};




  return (
    <div>
<Helmet>
  <title>Innova Crysta on Rent in Navi Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Innova Crysta on rent in Navi Mumbai with Royal Route Cabs. Premium 6–7 seater luxury cab for airport, outstation, and long-distance travel at best rates."
  />

  <meta
    name="keywords"
    content="innova crysta on rent in navi mumbai, innova crysta rental navi mumbai, innova crysta hire in navi mumbai, innova crysta car rental navi mumbai, innova crysta taxi service navi mumbai, book innova crysta in navi mumbai, innova crysta rental service navi mumbai, best innova crysta on rent navi mumbai, cheapest innova crysta rental navi mumbai, innova crysta airport pickup navi mumbai, innova crysta airport drop navi mumbai, innova crysta outstation rental navi mumbai, innova crysta for long trip navi mumbai, innova crysta on rent in vashi, innova crysta on rent in nerul, innova crysta on rent in kharghar, innova crysta on rent in panvel, ac innova crysta on rent in navi mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentinnavimumbai;